// Update these with the real business contact details.
export const BUSINESS = {
  name: "StillFusion LLC",
  owner: "Aleksei Torkhov",
  phone: "+19164953687",
  phoneDisplay: "(916) 495-3687",
  sms: "+19164953687",
  email: "info@stillfusionappliance.com",
  city: "Sacramento, CA",
};
